import script from "./NotificationMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationMenu.vue?vue&type=script&setup=true&lang=js"

import "./NotificationMenu.vue?vue&type=style&index=0&id=dde25a9e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dde25a9e"]])

export default __exports__